import React from "react";
import { Button, Col, Container, FormLabel, Row } from "react-bootstrap";
import { PickTicketSearchCriteria, RestReadRequest } from "../ds/ds.js";
import { LookupHandler, LookupResultDetails } from "../ds/lookup_ds.js";
import { Eraser, TickIcon } from "../gui_components/Icons.js";
import { InputTextbox, ShowError } from "../gui_components/UIComponents.js";
import { isEmptyString } from "../gui_components/Util.js";
import { PickTicketService } from "../services/PickTicketService.js";
export class PickTicketLineLookupHandler extends LookupHandler {
  constructor(companyCode, attribute_name, pickTicketCode) {
    super();
    this.attribute_name = attribute_name;
    this.lookupTitle = attribute_name + " Lookup";
    this.companyCode = companyCode;
    this.pickTicketCode = pickTicketCode;
    let resetCriteria = new PickTicketSearchCriteria();
    resetCriteria.companyCode = companyCode;
    this.resetCriteria = resetCriteria;
    // let newCriteria = new PickTicketSearchCriteria();
    // newCriteria.companyCode = companyCode;
    // this.newCriteria = newCriteria;
    let pickTicketLineLookupCriteria = new PickTicketSearchCriteria();
    pickTicketLineLookupCriteria.companyCode = this.companyCode;
    pickTicketLineLookupCriteria.pickTicketCode = this.pickTicketCode;
    let lookupCriteriaView = PickTicketLineLookupCriteraHandler(
      companyCode,
      pickTicketLineLookupCriteria
    );
    let lookupDataCallback = function (
      lookup_dialog,
      page_number,
      searchCriteria,
      filterText
    ) {
      this.fetchDataFromService(
        lookup_dialog,
        page_number,
        searchCriteria,
        filterText
      );
    };
    this.setDetails(
      lookupDataCallback,
      pickTicketLineLookupCriteria,
      lookupCriteriaView
    );
    this.initColumns();
  }
  initColumns() {
    this.addColumnDefinition(
      this.attribute_name,
      "pickTicketLineNumber",
      0,
      true
    ); //1
    this.addColumnDefinition("Item", "fabricStyleCode", 0, false); //3
    this.addColumnDefinition("Color", "colorCode", 0, false); //3
    this.addColumnDefinition("PickedQty", "pickedQuantity", 0, false); //3
  }
  readPickTicket = (lookup_dialog, pageNumber, searchCriteria) => {
    // let pt_criteria = new PickTicketSearchCriteria(); //To be fetched from CriteriaHandler
    // pt_criteria.companyCode = this.companyCode;
    // pt_criteria.pickTicketCode = searchCriteria.pickTicketCode
    // if (searchCriteria !== undefined && searchCriteria !== null) {
    //   pt_criteria.pickTicketStartsWith = searchCriteria.pickTicketStartsWith;
    //   pt_criteria.pickTicketContains = searchCriteria.pickTicketContains;
    //   pt_criteria.pickTicketCode = searchCriteria.pickTicketCode;
    //   pt_criteria.salesOrderNumber = searchCriteria.salesOrderNumber;
    //   pt_criteria.customerCode = searchCriteria.customerCode;
    // }
    // let pt_pageList = new PageListBean();
    // pt_pageList.pageSize = 50; //TODO --> Fetch from Config
    // pt_pageList.pageNumber = pageNumber;
    // pt_pageList.currentPage = pageNumber;
    // let pt_requestInput = new RestPickTicketListRequest();
    // pt_requestInput.pageInput = pt_pageList;
    // pt_requestInput.searchCriteria = pt_criteria;
    let request = new RestReadRequest();
    request.companyCode = this.companyCode;
    request.code = searchCriteria.pickTicketCode;
    PickTicketService.readPickTicket(
      request,
      (response) => this.readPickTicketResponse(response, lookup_dialog),
      this.loadPickTicketListError
    );
  };
  readPickTicketResponse = (response, lookup_dialog) => {
    let ptLineList = [];
    let ptData = null;
    let totalCount = 0;
    let currentPageNumber = 0;
    let pageSize = 0;
    if (response.data != null && response.data.pickTicket != null) {
      ptData = response.data.pickTicket;
      ptLineList = ptData.pickTicketLines;
      totalCount = ptLineList.length;
      currentPageNumber = 1;
      pageSize = 50;
    }
    let lookup_result_details = new LookupResultDetails();
    lookup_result_details.pageData = ptLineList;
    this.lookup_data = ptLineList;
    let total_count = 0;
    if (this.lookup_data != null) {
      total_count = this.lookup_data.length;
    }
    lookup_result_details.totalRecordsCount = totalCount;
    lookup_result_details.currentPageNumber = currentPageNumber;
    lookup_result_details.pageSize = pageSize;
    lookup_result_details.criteriaDisplayString = ""; //TODO
    lookup_dialog.updateResultCallBack(lookup_result_details);
  };
  loadPickTicketListError = (error) => {
    ShowError("Error : " + error);
  };
  fetchDataFromService(lookup_dialog, pageNumber, searchCriteria, filterText) {
    let search = { ...searchCriteria };
    if (search != null && search != "unDefined") {
      // if (isEmptyString(search.pickTicketCode)) {
      if (!isEmptyString(filterText)) {
        search.pickTicketCode = filterText;
        // this.searchCriteria = new PickTicketSearchCriteria();
      }
    }
    if (lookup_dialog != null) {
      this.readPickTicket(lookup_dialog, pageNumber, search);
    }
  }
}
const PickTicketLineLookupCriteraHandler = (
  companyCode,
  pickTicketLineLookupCriteria
) => {
  return class extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        searchCriteria: pickTicketLineLookupCriteria,
      };
      this.criteriaLookupHandler = React.createRef();
      this.focusRef = React.createRef();
    }
    componentDidMount() {
      let searchCriteria = this.state.searchCriteria;
      searchCriteria.companyCode = companyCode;
      this.setState({ searchCriteria: searchCriteria });
      if (this.focusRef.current) this.focusRef.current.focus();
    }
    continueButtonClick = () => {
      this.props.searchCriteriaCallBack(this.state.searchCriteria);
    };
    onChange = (e) => {
      let temp_searchCriteria = this.state.searchCriteria;
      temp_searchCriteria[e.target.name] = e.target.value;

      this.setState({ searchCriteria: temp_searchCriteria });
    };
    clearCriteria = () => {
      let searchCriteria = new PickTicketSearchCriteria();
      searchCriteria.companyCode = companyCode;
      this.setState({ searchCriteria: searchCriteria });
      if (this.focusRef.current) this.focusRef.current.focus();
    };
    onContainerKeyDown = (e) => {
      if (e.ctrlKey && e.keyCode == "191") {
        this.continueButtonClick();
      }
    };
    render() {
      let searchCriteria = this.state.searchCriteria;
      return (
        <div>
          <Container onKeyDown={this.onContainerKeyDown}>
            <Row>
              <Col sm={5}>
                <FormLabel>PickTicket#</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  id="pickTicketCode"
                  name="pickTicketCode"
                  onChange={this.onChange}
                  value={searchCriteria.pickTicketCode}
                />
              </Col>
            </Row>

            <Row className="popup_criteria_button_align-lookup">
              <Button
                ref={this.focusRef}
                className="header_buttons btn btn-primary btn-sm enterFocus"
                onClick={this.continueButtonClick}
              >
                <TickIcon />
                Continue
              </Button>
              <Button
                className="header_buttons btn btn-primary btn-sm enterFocus"
                onClick={this.clearCriteria}
              >
                <Eraser />
                Clear
              </Button>
            </Row>
          </Container>
        </div>
      );
    }
  };
};
